import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgAlertFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M12 2c.67 0 1.29.403 1.637 1.064l8.106 15.622c.34.68.343 1.517.006 2.199-.337.682-.962 1.106-1.642 1.115H3.893c-.68-.009-1.305-.433-1.642-1.115a2.508 2.508 0 01.006-2.2l8.106-15.621C10.71 2.404 11.331 2 12 2zm0 14a1 1 0 100 2 1 1 0 000-2zm0-7a1 1 0 00-1 1v4a1 1 0 002 0v-4a1 1 0 00-1-1z" }));
};
export default factorySvgIcon(SvgAlertFilled);
//# sourceMappingURL=SvgAlertFilled.js.map